module.exports = __webpack_public_path__ + "media/51.e9ead13a.mp3";